const AUTH_KEY = process.env.REACT_APP_AUTH_KEY || "auth_session";

// Guardar "sesión" en el front
export function setSession(user) {
  const payload = {
    user,
    lastActivity: Date.now(),
  };
  localStorage.setItem(AUTH_KEY, JSON.stringify(payload));
}

// Leer sesión
export function getSession() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    console.error("Error leyendo sesión:", err);
    return null;
  }
}

// Saber si hay sesión (sin checar tiempo)
export function isLoggedIn() {
  const session = getSession();
  return !!(session && session.user);
}

// Actualizar última actividad
export function updateLastActivity() {
  const session = getSession();
  if (!session) return;

  const now = Date.now();

  // Guardar dentro del objeto de sesión
  session.lastActivity = now;
  localStorage.setItem(AUTH_KEY, JSON.stringify(session));

  // 👇 Guardar también en una key directa, que es la que lees en Limpiador
  localStorage.setItem("lastActivity", String(now));
}

// Verificar si la sesión sigue activa según minutos de inactividad
export function isSessionActive(maxMinutes = 15) {
  const session = getSession();
  if (!session) return false;

  const now = Date.now();
  const last = session.lastActivity || 0;
  const diffMs = now - last;
  const maxMs = maxMinutes * 60 * 1000;

  return diffMs <= maxMs;
}

// Limpiar sesión (logout)
export function clearSession() {
  localStorage.removeItem(AUTH_KEY);
}
